import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Siteinformation extends Component {
    constructor(props){     
        super(props);   
        this.state = {
          errors: {},
          details:[],
          siteinfomasterlist:[],
          siteinfomaster:[],
          formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode},
          sitestatus:[{
            value: "NC",
            label: "NOT CLEARED",
          },
          {
            value: "NR",
            label: "NOT REQUIRED",
          },
          {
            value: "PC",
            label: "PARTIALLY CLEARED",
          },
          {
            value: "CL",
            label: "CLEARED",
          }]
         }  
        this.handleChange = this.handleChange.bind(this);  
        this.selecthandleChange = this.selecthandleChange.bind(this); 
        this.datepickerhandleChange = this.datepickerhandleChange.bind(this); 
        this.getdataafterload = this.getdataafterload.bind(this);  
        this.refreshvalue = this.refreshvalue.bind(this);    
      } 
      componentDidMount() {
        document.title = "Site Information"
        this.getdataafterload(); 
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;        
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/getsiteinfomaster`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.taskcode,
              "label" : d.siteinfo_discription          
            }))    
            this.setState({siteinfomaster: options})  
          }           
        });                  
      }  
      async getdataafterload()
      {
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;           
        Axios.post(`${process.env.REACT_APP_API_URL}partworks/getsiteinformation`,this.props.children)
        .then(result=>{
          if(result.status === 200){
            this.setState({details:result.data.data});           
          }      
        }); 
      }       
      handleValidation(){
        let formdetails = this.state.formdetails;        
        let errors = {};
        let formIsValid = true;
        
        //Site Name
        if(!formdetails["taskcode"]){
          formIsValid = false;
          errors["taskcode"] = "Select Site Name";
        }
        
        if(typeof formdetails["statecode"] !== "undefined"){
          if(!formdetails["statecode"].match(/^[0-9]+$/)){
            formIsValid = false;
            errors["taskcode"] = "Only Number";
          }      	
        } 
        //Status Name
        if(!formdetails["status"]){
            formIsValid = false;
            errors["status"] = "Please Select Status";
          }

          if(typeof formdetails["status"] !== "undefined"){
            if(!formdetails["status"].match(/^[A-Z]+$/)){
              formIsValid = false;
              errors["taskcode"] = "Only letters";
            }      	
          } 
        //Status Name
        if(!formdetails["m_date"]){
          formIsValid = false;
          errors["m_date"] = "Please Select Date";
        }         
        
      
        this.setState({errors: errors});
        return formIsValid;
      }      
      contactSubmit(e){        
        e.preventDefault();
        if(this.handleValidation()){
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const data =  this.state.formdetails;  
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/savesiteinformation`, data) 
            .then((responce) => { 
              const result = responce.data;
              if(result.status === 1){
                this.getdataafterload();  
                this.refreshvalue();       
                swal({
                  title: result.msg,
                  text: "Data Save Successfully",
                  icon: "success",
                  buttons: true
                })             
            }
            else{
              if(result.status === 401){
              swal("Error", result.message, "error"); 
              }else{
                swal("Error", result.msg, "error"); 
              }              
            }              
            });
        }   
      }   
      async refreshvalue(){ 
        this.setState({formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode}}); 
      }
      async siteinformationDelete(id,taskcode,dt){    
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const formdetails =  this.state.formdetails;
          formdetails['id'] = id;
          formdetails['taskcode'] = taskcode;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletesiteinformation`, formdetails) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
                this.refreshvalue();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "Parlimentery Constituency Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });          
      }                    
      async selecthandleChange(name,e) {
        let formdetails = this.state.formdetails; 
        formdetails[name] = e.value;  
        this.setState({formdetails});        
      }  
      datepickerhandleChange(name,e){
        let formdetails = this.state.formdetails;
        formdetails[name] = e.format('DD-MM-YYYY');
        this.setState({formdetails});
      }  
      async handleChange(event) {
        let formdetails = this.state.formdetails;
        let errors = this.state.errors;
        formdetails[event.target.name] = event.target.value;   
        errors[event.target.name] = ''; 
        this.setState({formdetails,errors});       
      }                      
    render() {
        return (
            <div className="box">
            <div className="box-body">
                <div className="box-header">
                <h3 className="box-title">Site Information</h3>
                    <div className="box-body">
            <form onSubmit= {this.contactSubmit.bind(this)} >
            <div className="col-md-12">
                <div className="col-md-4">
                    <div className="form-group">
                        <label>Site</label> 
                        <Select 
                            options={this.state.siteinfomaster} 
                            name="taskcode" 
                            value={this.state.siteinfomaster.filter(({value}) => value === this.state.formdetails.taskcode)  || ''} 
                            isClearable
                            onChange={this.selecthandleChange.bind(this,'taskcode')} />                        
                    </div>
                </div>	
                <div className="col-md-4">
                    <div className="form-group">
                        <label>Status</label> 
                        <Select 
                            options={this.state.sitestatus} 
                            name="status"  
                            isClearable
                            value={this.state.sitestatus.filter(({value}) => value === this.state.formdetails.status)  || ''} 
                            onChange={this.selecthandleChange.bind(this,'status')} /> 
                    </div>
                </div>			
                <div className="col-md-4">
                    <div className="form-group">
                        <label>Date</label> 
                        <DatePicker 
                            timeFormat={false}
                            onChange={this.datepickerhandleChange.bind(this,'m_date')}
                            dateFormat="DD-MM-YYYY" 
                            value={this.state.formdetails.m_date || ''}
                            closeOnSelect 
                        />                        
                     </div>
                </div>
                </div>
                <div className="col-md-12">
                <div className="col-md-4">
                    <div className="form-group">
                        <label>Remark</label> 
                        <input className="form-control" type="text" value={this.state.formdetails.remark  || '' } onChange={this.handleChange} name="remark" />
                    </div>
                </div>	
                <div className="col-md-4" style={{ padding: '2.3%'}}>
                  <input type="submit" className="btn btn-primary" value="Save" />
                </div>
                </div>
                </form>	
                <div className="col-md-12">
                <table className="table table-bordered" >
                <thead>
                    <tr>
                            <th>Sr No</th>
                            <th>Site</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Remark</th>
                            <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.details.map((value, index) => {
                                return (
                                    <tr key={value.sr}>
                                        <td>{value.sr}</td>
                                        <td>{value.siteinfo_discription}</td>
                                        <td>{value.taskstatus}</td>
                                        <td>{value.taskdate}</td>
                                        <td>{value.taskreference}</td>
                                        <td><button onClick={this.siteinformationDelete.bind(this,value.id,value.taskcode)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                    </tr>
                                )
                            })}                   
                </tbody>
                <tfoot>
                    <tr>
                            <th>Sr No</th>
                            <th>Site</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Remark</th>
                            <th>Delete</th>
                    </tr>
                </tfoot>				
                </table>			
                </div>
                </div>
                </div>
                </div>
                </div>
        )
    }
}

export default Siteinformation
